module.exports = __webpack_public_path__ + "img/payment_active.d386e108.svg";